import React, { useState } from 'react';
import { t } from 'i18next';

import Header from '../../main/components/Header';
import Path from '../../path/ui/Path';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import { NotifFilterTabButtons } from '../components/NotifFilterTabButtons';
import Articles from '../../aboutus/components/Articles';

import backIcon from '../../../assets/icons/backicon.svg';

const Main = () => {
    const [tab, setTab] = useState('agroland');

    return (
        <div className="min-h-screen bg-[#F9F9F9]">
            <Header />

            {/* Breadcrumb — desktop only */}
            <div className="hidden md:block">
                <Path currentPath={t('notifications')} />
            </div>

            {/* Page content */}
            <div className="max-w-[1060px] mx-auto px-4 md:px-6 pb-24 md:pb-10 pt-0 md:pt-2">

                {/* Header card */}
                <div className="bg-white rounded-2xl px-5 pt-5 pb-4 mb-4 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">

                    {/* Mobile top row: back + title */}
                    <div className="flex items-center gap-3 mb-4 md:mb-3">
                        <button
                            onClick={() => window.history.back()}
                            className="
                                md:hidden w-9 h-9 rounded-xl bg-[#F9F9F9]
                                flex items-center justify-center shrink-0
                                border-none cursor-pointer
                                hover:bg-[#e8f5ea] transition-colors duration-150
                            "
                        >
                            <img src={backIcon} alt="back" width={20} height={20} />
                        </button>

                        <h1 className="text-[22px] md:text-[28px] font-bold text-[#222222] m-0 leading-tight">
                            {t('news')}
                        </h1>
                    </div>

                    {/* Filter tabs */}
                    <NotifFilterTabButtons tab={tab} setTab={setTab} />
                </div>

                {/* Articles grid */}
                <div className="mt-0">
                    {tab === 'agroland'    && <Articles service="service"    />}
                    {tab === 'promotions'  && <Articles service="promotions" />}
                </div>
            </div>

            <MobileBottomBar />
        </div>
    );
};

export default Main;
